import { render } from "./ReportCreate.vue?vue&type=template&id=0165de30"
import script from "./ReportCreate.vue?vue&type=script&lang=js"
export * from "./ReportCreate.vue?vue&type=script&lang=js"
script.render = render

export default script